import React from "react";
import "./loading.scss";

const Loading = () => {
  return (
    <div>
      <div className="loader">Loading...</div>
    </div>
  );
};

export default Loading;
